import { render, staticRenderFns } from "./Add_partner.vue?vue&type=template&id=3a98b75e&scoped=true&"
import script from "./Add_partner.vue?vue&type=script&lang=js&"
export * from "./Add_partner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a98b75e",
  null
  
)

export default component.exports